import { Component, Input } from '@angular/core';
import { CommentSummaryModel } from '../../services/ai.service';

@Component({
  selector: 'tangram-comment-summary-card',
  templateUrl: './comment-summary-card.component.html',
  styleUrls: ['./comment-summary-card.component.scss']
})
export class CommentSummaryCardComponent {
  @Input() summary: CommentSummaryModel | null = null;
  @Input() loading: boolean = false;
  @Input() error: string = '';
}
